// ============================================
// Google İlan Verme - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleIlanVermeContent: BlogContent = {
  tableOfContents: [
    { id: "ilan-nedir", title: "Google İlanı Nedir?" },
    { id: "ilan-turleri", title: "İlan Türleri" },
    { id: "etkili-ilan", title: "Etkili İlan Oluşturma" },
    { id: "maliyet", title: "Maliyet ve Bütçe" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google ilan verme</strong> stratejileri ve etkili ilan oluşturma teknikleri. Başarılı kampanyalar için rehber."
    }
  ]
};

export default googleIlanVermeContent;
